/* Video Section – Sacred Modern Design
 * Dark section with embedded YouTube video
 * Annam introduces AYU
 */
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { Play } from "lucide-react";
import { useState } from "react";
import { IMAGES } from "@/lib/constants";
import { useI18n } from "@/contexts/I18nContext";

export default function VideoSection() {
  const { t } = useI18n();
  const { ref, isVisible } = useScrollAnimation();
  const [playing, setPlaying] = useState(false);

  return (
    <section className="section-dark py-24 lg:py-32 relative overflow-hidden" ref={ref}>
      {/* Mandala overlay */}
      <div className="absolute inset-0 mandala-overlay pointer-events-none" />

      <div className="container relative z-10">
        <div
          className={`text-center max-w-3xl mx-auto mb-12 transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <span className="text-sm font-semibold tracking-[0.2em] uppercase text-[oklch(0.52_0.09_128)]" style={{ fontFamily: "var(--font-body)" }}>
            {t("landing.video.badge")}
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[oklch(0.93_0.015_80)] mt-4 mb-6">
            {t("landing.video.heading")}
          </h2>
          <p className="text-lg text-[oklch(0.7_0.02_80)]" style={{ fontFamily: "var(--font-body)" }}>
            {t("landing.video.description")}
          </p>
        </div>

        {/* Video Container */}
        <div
          className={`max-w-4xl mx-auto transition-all duration-700 delay-200 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <div className="relative rounded-2xl overflow-hidden border border-[oklch(0.52_0.09_128/0.2)] shadow-2xl aspect-video bg-[oklch(0.12_0.02_280)]">
            {!playing ? (
              <div className="relative w-full h-full">
                <img
                  src={IMAGES.herbs}
                  alt={t("landing.video.videoPreview")}
                  className="w-full h-full object-cover opacity-60"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <button
                    onClick={() => setPlaying(true)}
                    className="w-20 h-20 rounded-full bg-[oklch(0.52_0.09_128)] flex items-center justify-center hover:scale-110 transition-transform duration-300 shadow-lg"
                    style={{ boxShadow: "0 0 40px oklch(0.52 0.09 128 / 0.3)" }}
                    aria-label={t("landing.video.playAriaLabel")}
                  >
                    <Play className="text-white ml-1" size={32} fill="white" />
                  </button>
                </div>
                <div className="absolute bottom-6 left-6">
                  <p className="text-[oklch(0.9_0.01_80)] font-semibold text-lg" style={{ fontFamily: "var(--font-display)" }}>
                    {t("landing.video.previewTitle")}
                  </p>
                  <p className="text-[oklch(0.7_0.02_80)] text-sm mt-1">
                    {t("landing.video.previewSubtitle")}
                  </p>
                </div>
              </div>
            ) : (
              <iframe
                src="https://www.youtube-nocookie.com/embed/UK5oZQZognA?autoplay=1&rel=0&modestbranding=1"
                title="AYU Einführung"
                className="w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
